import {ALL_PERMISSIONS} from '../../helpers/consts'

export interface IPolicytoolsRouteInfo {
  id: number
  name: string
  route: string
  perm?: string
  group?: string | string[]
}

export const ROUTES_POLICYTOOLS_SETTINGS: IPolicytoolsRouteInfo[] = [
  {
    id: 1,
    name: 'Email Settings',
    route: '/policytools-settings/email',
    perm: ALL_PERMISSIONS.VIEW_POLICYTOOLS_SETTINGS,
    group: 'SuperAdministrador',
  },
  {
    id: 2,
    name: 'Organizations',
    route: '/organizations',
    perm: ALL_PERMISSIONS.VIEW_ORGANIZATIONS,
    group: 'SuperAdministrador',
  },
  {
    id: 3,
    name: 'App Token Generator',
    route: '#token-generator',
    perm: ALL_PERMISSIONS.VIEW_APP_TOKENS,
    group: 'SuperAdministrador',
  },
  {
    id: 4,
    name: 'System Monitor',
    route: '/system-monitor',
    perm: ALL_PERMISSIONS.VIEW_SYSTEM_MONITOR,
    group: 'SuperAdministrador',
  },
]

// Ids cuyo click debe abrir un modal en vez de navegar (ver NavPolicytoolsSettingsDesktop).
export const TOKEN_GENERATOR_ROUTE_ID = 3
